export const NUMBER_ERROR_MESSAGE = 'Invalid number. eg: 55, 43a, 12-14'
export const POSTCODE_ERROR_MESSAGE = 'Postcode invalid'
export const REQUIRED_ERROR_MESSAGE = 'This field is required'

export const UNIT_NUMBER_KEY = 'address_unit_number'
export const UNIT_TYPE_KEY = 'address_unit_type'
export const STREET_NUMBER_KEY = 'address_street_number'
export const STREET_NAME_KEY = 'address_street_name'
export const STREET_TYPE_KEY = 'address_street_type'
export const SUBURB_KEY = 'address_suburb'
export const STATE_KEY = 'address_state'
export const POSTCODE_KEY = 'address_postcode'
export const STATE_SELECTION = [
  'VIC',
  'NSW',
  'ACT',
  'QLD',
  'NT',
  'SA',
  'TAS',
  'WA',
]
export const UNIT_TYPE_SELECTION = [
  'Apartment',
  'Flat',
  'Level',
  'Suite',
  'Shop',
  'Unit',
]
// List taken from https://shop.vodafone.com.au/checkout
// JSON.stringify(Array.from(document.querySelectorAll('#homeAddressStreetType option')).map(opt => opt.innerHTML))
export const STREET_TYPE_SELECTION = [
  /* Common */
  'Avenue',
  'Crescent',
  'Highway',
  'Lane',
  'Parade',
  'Place',
  'Road',
  'Street',

  /* The rest */
  'Alley',
  'Alleyway',
  'Amble',
  'Anchorage',
  'Approach',
  'Arcade',
  'Artery',
  'Basin',
  'Beach',
  'Bend',
  'Block',
  'Boulevard',
  'Brace',
  'Brae',
  'Break',
  'Bridge',
  'Broadway',
  'Brow',
  'Bypass',
  'Byway',
  'Causeway',
  'Centre',
  'Centreway',
  'Chase',
  'Circle',
  'Circlet',
  'Circuit',
  'Circus',
  'Close',
  'Colonnade',
  'Common',
  'Concourse',
  'Copse',
  'Corner',
  'Corso',
  'Court',
  'Courtyard',
  'Cove',
  'Crest',
  'Cross',
  'Crossing',
  'Crossroad',
  'Crossway',
  'Cruiseway',
  'Cutting',
  'Dale',
  'Dell',
  'Deviation',
  'Dip',
  'Distributor',
  'Drive',
  'Driveway',
  'Edge',
  'Elbow',
  'End',
  'Entrance',
  'Esplanade',
  'Estate',
  'Expressway',
  'Extension',
  'Fairway',
  'Firetrail',
  'Flat',
  'Follow',
  'Footway',
  'Foreshore',
  'Formation',
  'Freeway',
  'Front',
  'Frontage',
  'Gap',
  'Garden',
  'Gardens',
  'Gate',
  'Gates',
  'Glade',
  'Glen',
  'Grange',
  'Green',
  'Ground',
  'Grove',
  'Gully',
  'Heights',
  'Highroad',
  'Hill',
  'Interchange',
  'Intersection',
  'Junction',
  'Key',
  'Landing',
  'Laneway',
  'Lees',
  'Line',
  'Link',
  'Little',
  'Lookout',
  'Loop',
  'Lower',
  'Mall',
  'Meander',
  'Mew',
  'Mews',
  'Motorway',
  'Mount',
  'Nook',
  'Outlook',
  'Park',
  'Parklands',
  'Parkway',
  'Part',
  'Pass',
  'Path',
  'Pathway',
  'Piazza',
  'Plateau',
  'Plaza',
  'Pocket',
  'Point',
  'Port',
  'Promenade',
  'Quad',
  'Quadrangle',
  'Quadrant',
  'Quay',
  'Quays',
  'Ramble',
  'Ramp',
  'Range',
  'Reach',
  'Reserve',
  'Rest',
  'Retreat',
  'Ride',
  'Ridge',
  'Ridgeway',
  'Ring',
  'Rise',
  'River',
  'Riverway',
  'Riviera',
  'Roads',
  'Roadside',
  'Roadway',
  'Ronde',
  'Rosebowl',
  'Rotary',
  'Round',
  'Route',
  'Row',
  'Rue',
  'Run',
  'Siding',
  'Slope',
  'Sound',
  'Spur',
  'Square',
  'Stairs',
  'Steps',
  'Strand',
  'Strip',
  'Subway',
  'Tarn',
  'Terrace',
  'Thoroughfare',
  'Tollway',
  'Top',
  'Tor',
  'Towers',
  'Track',
  'Trail',
  'Trailer',
  'Triangle',
  'Trunkway',
  'Turn',
  'Underpass',
  'Upper',
  'Vale',
  'Viaduct',
  'View',
  'Villas',
  'Vista',
  'Wade',
  'Walk',
  'Walkway',
  'Way',
  'Wharf',
  'Wynd',
  'Yard',
]



// WEBPACK FOOTER //
// ./components/Address/constants.js